<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="选择机构">
              <j-search-select-tag
                placeholder="请选择机构"
                v-model="queryParam.orgCode"
                @change="handleOrgCodeChange"
                dict="sys_depart,depart_Name,org_Code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="年度">
              <a-select placeholder="请选择" v-model="queryParam.year">
                <a-select-option :value="lastYear">{{lastYear}}</a-select-option>
                <a-select-option :value="currYear">{{currYear}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="月份">
              <a-select placeholder="请选择" v-model="queryParam.month">
                <a-select-option value="01">1月</a-select-option>
                <a-select-option value="02">2月</a-select-option>
                <a-select-option value="03">3月</a-select-option>
                <a-select-option value="04">4月</a-select-option>
                <a-select-option value="05">5月</a-select-option>
                <a-select-option value="06">6月</a-select-option>
                <a-select-option value="07">7月</a-select-option>
                <a-select-option value="08">8月</a-select-option>
                <a-select-option value="09">9月</a-select-option>
                <a-select-option value="10">10月</a-select-option>
                <a-select-option value="11">11月</a-select-option>
                <a-select-option value="12">12月</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="10">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
        <!--<a-button type="primary" icon="import">导入</a-button>-->
      <!--</a-upload>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <span style="margin-right: 60px;">币别：{{fcurrencyName}}</span>
        <span style="margin-right: 120px;"> 保费：已开票净保费</span>
        <span style="float:right; ">金额单位：万元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
      </a-table>
    </div>

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction,postAction } from '@/api/manage'
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"

  export default {
    name: 'BizBusinessMonthReportList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag
    },
    data () {
      return {
        description: '监管报表', // 月度业务提报
        disableMixinCreated: true,
        fcurrencyName:'人民币',
        lastYear: 2000,
        currYear: 2000,
        selectedOrgName:'',
        orgName:'',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:'机构编号',
          //   align:"center",
          //   dataIndex: '',
          //   customRender: function() {
          //     return "91370102780772238L"
          //   }
          // },
          {
            title:'机构名称',
            align:"center",
            dataIndex: '',
            customRender: () => {
              return this.orgName;
            }
          },
          {
            title:'类型',
            align:"center",
            dataIndex: '',
            customRender: function() {
              return "经纪"
            }
          },
          {
            title:'性质',
            align:"center",
            dataIndex: '',
            customRender: function() {
              return "法人机构";
            }
          },
          {
            title:'年份',
            align:"center",
            dataIndex: 'year'
          },
          {
            title:'月份',
            align:"center",
            dataIndex: 'month'
          },
          {
            title: '员工数量',
            children:[
              {
                title:'外勤人数',
                align:"center",
                dataIndex: 'outWorker'
              },
              {
                title:'内勤人数',
                align:"center",
                dataIndex: 'officeWorker'
              },
              {
                title:'总人数',
                align:"center",
                dataIndex: 'totalWorker'
              },
              {
                title:'新员工',
                align:"center",
                dataIndex: 'newWorker'
              },
            ]
          },
          {
            title: '财产保险(万元)',
            children:[
              {
                title:'本年累计',
                className: 'column-money',
                dataIndex: 'productThis',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'上年同期',
                className: 'column-money',
                dataIndex: 'productLast',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'同比',
                align:"center",
                dataIndex: 'productGrew',
                customRender: function(text) {
                  return !text ? '': text + '%';
                }
              }
            ]
          },
          {
            title: '人身保险(万元)',
            children: [
              {
                title:'新单本年累计',
                className: 'column-money',
                dataIndex: 'lifeThis',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'新单上年同期',
                className: 'column-money',
                dataIndex: 'lifeLast',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'续期保费金额',
                className: 'column-money',
                dataIndex: 'renewPremium',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'同比',
                className: 'column-money',
                dataIndex: 'lifeGrew',
                customRender: function(text) {
                  return !text ? '': text + '%';
                }
              }
            ]
          },
          {
            title:'总保费金额(万元)',
            children:[
              {
                title:'本年累计',
                className: 'column-money',
                dataIndex: 'premiumThis',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'上年同期',
                className: 'column-money',
                dataIndex: 'premiumLast',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'同比',
                className: 'column-money',
                dataIndex: 'premiumGrew',
                customRender: function(text) {
                  return !text ? '': text + '%';
                }
              },
            ]
          },
          {
            title:'咨询业务收入',
            className: 'column-money',
            dataIndex: 'consultIncome',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          {
            title:'总业务收入',
            className: 'column-money',
            dataIndex: 'totalIncome',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          }
        ],
        url: {
          list: "/bms/regulatoryReport/list",
          //exportXlsUrl: "/bms/bizFinancialBalance/exportXls",
          //importExcelUrl: "bms/bizFinancialBalance/importExcel",
        },
      }
    },
    created() {
      this.currYear = (new Date()).getFullYear();
      this.lastYear = this.currYear - 1;
      //this.loadData()
    },
    methods: {
      searchQuery(){
        if(this.queryParam.orgCode && this.queryParam.year && this.queryParam.month){
          this.loadData()
        }
      },
      loadData() {
        if (!this.url.list) {
          this.$message.error("请设置url.list属性!")
          return
        }

        this.loading = true;
        let param = {orgCode: this.queryParam.orgCode, year: this.queryParam.year, month: this.queryParam.month}
        postAction(this.url.list, param).then((res) => {
          if (res.success) {
            this.dataSource = res.result;
            this.afterLoadData(this.dataSource);
          } else {
            this.dataSource = []
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      //初始加载数据后会被调用
      afterLoadData(){
        this.orgName = this.selectedOrgName
      },
      handleOrgCodeChange(selectedValue, selectedText){
        if(selectedText){
          this.selectedOrgName = selectedText //获取选择的名称
        }
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }
</style>